import { jwtDecode } from "jwt-decode";
import { APP_CONST } from "../../Constants/app.constant";
import {
  localStorageGetItem,
  localStorageRemoveItem,
  localStorageSetItem,
} from "../../utils/Storage/storageUtils";
import { getUserPersonna } from "../../utils/Helper";

export const saveKeycloakDetails = (keycloak) => {
  // Ensure keycloak token exists before attempting to decode
  if (!keycloak?.token) {
    console.warn("Cannot set keycloak storage - no token available");
    return;
  }

  try {
    const decoded = jwtDecode(keycloak.token);

    // Validate that token has required fields
    if (!decoded.email) {
      console.error("Token missing required email field");
      return;
    }

    // Update all storage keys with new token data
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.ACCESS_TOKEN,
      `${keycloak.token}`,
    );
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.REFRESH_TOKEN,
      `${keycloak.refreshToken}`,
    );
    localStorageSetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.LOGGED_IN, "true");
    localStorageSetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.EXP, decoded.exp);
    localStorageSetItem(APP_CONST.KEYCLOAK_STORAGE_KEYS.IAT, decoded.iat);
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.EMAIL_ID,
      `${decoded.email}`,
    );

    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.AUTH_SERVER_ID,
      `${decoded.upn}`,
    );

    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.FULL_NAME,
      decoded?.given_name,
    );
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.USER_GROUPS,
      `${decoded.groups}`,
    );
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.USER_PERSONA,
      getUserPersonna(),
    );
    localStorageSetItem(
      APP_CONST.KEYCLOAK_STORAGE_KEYS.IS_ADMIN,
      getUserPersonna() === APP_CONST.ADMIN,
    );
  } catch (error) {
    console.error("Error setting keycloak storage:", error);
  }
};

export const clearKeycloakStorage = () => {
  for (const key of Object.values(APP_CONST.KEYCLOAK_STORAGE_KEYS)) {
    localStorageRemoveItem(key);
  }
};

export const setGalleryStorage = () => {
  console.log("[Keycloak] Initializing studio storage");
  // Only initialize if they don't already exist
  const hasUnitsData = !!localStorageGetItem(APP_CONST.UNITS_DATA);
  const hasSelectedUnitsData = !!localStorageGetItem(
    APP_CONST.SELECTED_UNITS_DATA,
  );
  console.log("[Keycloak] Studio storage check", {
    hasUnitsData,
    hasSelectedUnitsData,
  });
  if (!hasUnitsData) {
    console.log("[Keycloak] Setting empty UNITS_DATA");
    localStorageSetItem(APP_CONST.UNITS_DATA, JSON.stringify([]));
  }
  if (!hasSelectedUnitsData) {
    console.log("[Keycloak] Setting empty SELECTED_UNITS_DATA");
    localStorageSetItem(APP_CONST.SELECTED_UNITS_DATA, JSON.stringify([]));
  }
  console.log("[Keycloak] Studio storage initialization complete");
};
